import React from "react";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { AiOutlineLeft } from "react-icons/ai";

import { useNavigate } from "react-router-dom";
import { InterviewList } from "../dashboard/create";
import HelpCenter from "../reusble_components/helpCenter";
export default function CompanyInterviewsList() {
  const { PopupStore, UserStore, InterviewStore } = useStores();
  // const [isClicked, setIsClicked] = useState(true);
  const navigate = useNavigate();

  const closeThisPopUP = () => {
    // PopupStore.setCreateInterview(false);
    // PopupStore.setCompanyInterview(false);
    // handlePopup();
    navigate("/company/interviews");
  };

  return useObserver(() => (
    <>
      <HelpCenter />
      <div className="flex flex-col relative items-center w-[90%] mx-auto h-full py-5 md:mt-0 lg:mt-0 mt-[15%]">
        <h1 className="gil-med text-2xl md:mt-0 lg:mt-0 mt-[10%]">
          Choose your interview type
        </h1>
        <button
          className="flex items-center text-primary  gap-2 text-xl cursor-pointer absolute left-0 top-[3%] md:top-[6%] lg:top-[7%]"
          onClick={closeThisPopUP}>
          <AiOutlineLeft /> Back
        </button>

        <InterviewList fromCompany={true} className="absolute right-10" />
      </div>
    </>
  ));
}
